module.exports = __webpack_public_path__ + "static/img/photoshop.bbedb3df.png";